import React, { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Plus, Loader2 } from "lucide-react";

export function NewTicketDialog({ onCreated }) {
  const [open, setOpen] = useState(false);
  const [subject, setSubject] = useState("");
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/support/tickets", { subject, text });
      toast.success("تم إرسال تذكرتك، سيرد عليك فريق خدمة العملاء قريباً");
      setOpen(false); setSubject(""); setText("");
      onCreated(data);
    } catch (ex) {
      toast.error(formatApiError(ex.response?.data?.detail));
    }
    setBusy(false);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button className="rounded-full gap-2" data-testid="new-ticket-btn"><Plus className="w-4 h-4" /> تذكرة جديدة</Button>
      </DialogTrigger>
      <DialogContent dir="rtl" data-testid="new-ticket-dialog">
        <DialogHeader><DialogTitle>تواصل مع خدمة العملاء</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label className="mb-1.5 block">الموضوع</Label>
            <Input value={subject} onChange={(e) => setSubject(e.target.value)} maxLength={120} placeholder="مثال: مشكلة في الدفع" data-testid="ticket-subject-input" />
          </div>
          <div>
            <Label className="mb-1.5 block">اشرح مشكلتك أو استفسارك</Label>
            <Textarea value={text} onChange={(e) => setText(e.target.value)} rows={5} maxLength={4000} data-testid="ticket-text-input" />
            <p className="text-xs text-muted-foreground mt-1">يمكنك إرفاق صور أو ملفات PDF داخل المحادثة بعد إنشاء التذكرة.</p>
          </div>
          <Button type="submit" className="w-full rounded-xl" disabled={busy || subject.trim().length < 3 || !text.trim()} data-testid="ticket-submit-btn">
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "إرسال"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
